import {Empty} from '../../layout/empty/empty';
import {LangKeyType} from '../../provider/locale/translation/type';

import * as styles from './workload.scss';

type PropsType = {
    textKey: LangKeyType;
};

export function WorkloadEmpty(props: PropsType): JSX.Element {
    const {textKey} = props;

    return <Empty secondaryText={textKey} secondaryTextClassName={styles.Workload_emptyText} />;
}
